import dynamic from "next/dynamic";
const AdaChatbotTestIframeComponent = dynamic(()=>import("./ada-chatbot-test-iframe-component"));
import AdaChatbotTestIframeConfig from "./ada-chatbot-test-iframe-config";
import AdaChatbotTestIframeAdvancedConfig from "./ada-chatbot-test-iframe-advanced-config";
export default {
    AdaChatbotTestIframeComponent,
    AdaChatbotTestIframeConfig,
    AdaChatbotTestIframeAdvancedConfig
};
